export default function textGeneral() {
  return {
    _id: false,
    type: 'droplet.textGeneral',
    text: 'Click here to start typing your text.',
    mediaQueries: [],
    pageCSS: false,
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/text-general/droplet.schema.js